import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiService, { getImageUrl } from "../../services/api";

function DestinationTwo() {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0); // Will be set dynamically

    useEffect(() => {
        const fetchDestinations = async () => {
            try {
                setLoading(true);
                // Try to get featured destinations first
                const response = await apiService.getFeaturedTourDestinations();
                console.log('Featured Tour Destinations Response:', response);
                
                let destinationsData = [];
                if (response.results && response.results.length > 0) {
                    destinationsData = response.results;
                } else if (response.length > 0) {
                    destinationsData = response;
                } else {
                    // Fallback to regular destinations if no featured ones
                    const fallbackResponse = await apiService.getTourDestinations();
                    console.log('Tour Destinations Fallback Response:', fallbackResponse);
                    destinationsData = fallbackResponse.results || fallbackResponse || [];
                }
                
                // Limit to 4 destinations for the home page display
                const limitedDestinations = destinationsData.slice(0, 4);
                setDestinations(limitedDestinations);
                
                // Set the last destination as active by default (matching original design)
                if (limitedDestinations.length > 0) {
                    setActiveIndex(limitedDestinations.length - 1);
                }
            } catch (error) {
                console.error('Error fetching tour destinations:', error);
                // Fallback to static data if API fails
                const fallbackDestinations = [
                    { name: "Thailand", image: "destination_2_1.jpg", tour_count: 28, id: 1 },
                    { name: "Belgium", image: "destination_2_2.jpg", tour_count: 15, id: 2 },
                    { name: "Island", image: "destination_2_3.jpg", tour_count: 22, id: 3 },
                    { name: "Maldives", image: "destination_2_4.jpg", tour_count: 25, id: 4 },
                ];
                setDestinations(fallbackDestinations);
                setActiveIndex(3);
            } finally {
                setLoading(false);
            }
        };
        
        fetchDestinations();
    }, []);

    return (
        <div
            className="bg-top-center position-relative space"
            id="destination-sec"
            style={{ backgroundImage: "url('/assets/img/bg/line-pattern2.png')", backgroundRepeat: "no-repeat" }}
        >
            <div className="container shape-mockup-wrap">
                <div className="title-area text-center">
                    <span className="sub-title">Top Destination</span>
                    <h2 className="sec-title">Our Featured Destination</h2>
                </div>
                <div className="row">
                    <div className="destination-list-area">
                        {loading ? (
                            // Loading state with skeleton cards
                            Array.from({ length: 4 }, (_, index) => (
                                <div key={index} className="destination-list-wrap">
                                    <div className="destination-list" style={{ 
                                        backgroundImage: `url('/assets/img/destination/destination_2_${index + 1}.jpg')`,
                                        opacity: 0.7
                                    }}>
                                        <div className="destination-content">
                                            <h4 className="box-title">
                                                <span>Loading...</span>
                                            </h4>
                                            <span className="destination-subtitle">-- Listing</span>
                                        </div>
                                        <div className="th-btn style2">Loading</div>
                                    </div>
                                </div>
                            ))
                        ) : destinations.length > 0 ? (
                            // Dynamic destinations from API
                            destinations.map((item, index) => {
                                const imageUrl = getImageUrl(item.main_image) || 
                                               (item.image && getImageUrl(item.image)) ||
                                               `/assets/img/destination/destination_2_${(index % 4) + 1}.jpg`;
                                
                                return (
                                    <div
                                        key={item.id || index}
                                        className={`destination-list-wrap ${index === activeIndex ? "active" : ""}`}
                                        onClick={() => setActiveIndex(index)}
                                    >
                                        <div
                                            className="destination-list"
                                            style={{ backgroundImage: `url('${imageUrl}')` }}
                                        >
                                            <div className="destination-content">
                                                <h4 className="box-title">
                                                    <Link to={`/destination/${item.id || item.slug || index + 1}`}>
                                                        {item.name || item.city || 'Unknown Destination'}
                                                    </Link>
                                                </h4>
                                                <span className="destination-subtitle">
                                                    {item.tour_count || item.listings || '0'} Listing{(item.tour_count !== 1 && item.listings !== 1) ? 's' : ''}
                                                </span>
                                            </div>
                                            <Link to={`/destination/${item.id || item.slug || index + 1}`} className="th-btn style2">
                                                {item.starting_price ? `From $${item.starting_price}` : 'Book Now'}
                                            </Link>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            // Fallback static destinations
                            [
                                { name: "Thailand", image: "destination_2_1.jpg", listings: 28, id: 1 },
                                { name: "Belgium", image: "destination_2_2.jpg", listings: 15, id: 2 },
                                { name: "Island", image: "destination_2_3.jpg", listings: 22, id: 3 },
                                { name: "Maldives", image: "destination_2_4.jpg", listings: 25, id: 4 },
                            ].map((item, index) => (
                                <div
                                    key={item.id}
                                    className={`destination-list-wrap ${index === 3 ? "active" : ""}`}
                                    onClick={() => setActiveIndex(index)}
                                >
                                    <div
                                        className="destination-list"
                                        style={{ backgroundImage: `url('/assets/img/destination/${item.image}')` }}
                                    >
                                        <div className="destination-content">
                                            <h4 className="box-title">
                                                <Link to={`/destination/${item.id}`}>{item.name}</Link>
                                            </h4>
                                            <span className="destination-subtitle">{item.listings} Listing</span>
                                        </div>
                                        <Link to={`/destination/${item.id}`} className="th-btn style2">
                                            Book Now
                                        </Link>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
                <div className="destination-btn text-center mt-60">
                    <Link to="/destination" className="th-btn style3 th-icon">
                        View All
                    </Link>
                </div>
                {/* Shape Mockups with Inline Styles */}
                <div 
                    className="shape-mockup movingX d-none d-xl-block"
                    style={{ top: "8%", left: "-15%" }}
                >
                    <img src="/assets/img/shape/shape_2_1.png" alt="shape" />
                </div>
                <div 
                    className="shape-mockup jump d-none d-xl-block"
                    style={{ top: "23%", right: "-14%" }}
                >
                    <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
                </div>
                <div 
                    className="shape-mockup spin d-none d-xl-block"
                    style={{ bottom: "21%", left: "-14%" }}
                >
                    <img src="/assets/img/shape/shape_2_3.png" alt="shape" />
                </div>
                <div 
                    className="shape-mockup movingX d-none d-xl-block"
                    style={{ bottom: "12%", right: "-14%" }}
                >
                    <img src="/assets/img/shape/shape_2_4.png" alt="shape" />
                </div>
            </div>
        </div>
    );
}

export default DestinationTwo;
